import React from 'react';
import { StyleSheet, TextInput, View } from './base_components';

import TextButton from './buttons/text_button';

const styles = StyleSheet.create({
  userAdd: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  userInput: {
    marginTop: '0.5em',
    width: '10em',
    height: '2.5em',
    marginRight: '1em',
    paddingLeft: '1em',
    color: '#333',
    fontSize: '1.2em',
    backgroundColor: '#eee',
    borderRadius: '0.4em',
  },
  passwordInput: {
    marginTop: '0.5em',
    width: '10em',
    height: '2.5em',
    paddingLeft: '1em',
    marginRight: '1em',
    color: '#333',
    fontSize: '1.2em',
    backgroundColor: '#eee',
    borderRadius: '0.4em',
  },
  addButton: {
    marginTop: '0.5em',
    height: '3em',
  },
});

type Props = {
  style?: any;
  onAdd: (props: any) => null;
};
type State = {
  user_name: string;
  email: string;
  password: string;
};

export default class UserAdd extends React.PureComponent<Props, State> {
  state = {
    user_name: '',
    email: '',
    password: '',
  };

  _onAddPress = () => {
    const { user_name, email, password } = this.state;
    if (!user_name || !password) {
      window.alert('User name and password is required.');
    } else {
      this.props.onAdd({ user_name, password, email });
    }
  };

  render() {
    const { style } = this.props;

    return (
      <View style={[styles.userAdd, style]}>
        <TextInput
          style={styles.userInput}
          placeholder='User Name'
          value={this.state.user_name}
          onChangeText={(user_name) => this.setState({ user_name })}
        />
        <TextInput
          style={styles.userInput}
          placeholder='Email'
          value={this.state.email}
          onChangeText={(email) => this.setState({ email })}
        />
        <TextInput
          style={styles.passwordInput}
          placeholder='Password'
          value={this.state.password}
          onChangeText={(password) => this.setState({ password })}
        />
        <TextButton
          style={styles.addButton}
          text='Add User'
          onPress={this._onAddPress}
        />
      </View>
    );
  }
}
